module.exports = __webpack_public_path__ + "assets/futurecraft-7153128edf1dacbbbdda2442ce6459f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/futurecraft.jpg
// module id = 512
// module chunks = 1